module.exports = __webpack_public_path__ + "assets/img/bg-startcreating.aeb8b427ccbd59fefc28bdbdc2fbc4de.svg";